<template lang="pug">
  .user-team-list
    .user-team-table(
      :style="{'grid-template-columns': gridLayout}"
    )
      HeaderCell(
        v-for="cell in titleList" :key="cell.id"
      ) {{cell.title}}
</template>

<script>
import HeaderCell from './components/HeaderCell';
export default {
  components: {
    HeaderCell
  },
  data: () => ({
    titleList: [
      {
        id: 0,
        title: 'Контакты',
        width: '2fr'
      },
      {
        id: 1,
        title: 'Telegram',
        width: '1fr'
      },
      {
        id: 2,
        title: 'Email',
        width: '1fr'
      },
      {
        id: 3,
        title: 'Уроков открыто',
        width: '1fr'
      },
      {
        id: 4,
        title: 'Уроков пройдено',
        width: '1fr'
      },
      {
        id: 5,
        title: 'Уроков проверено',
        width: '1fr'
      },
      {
        id: 6,
        title: 'Настройки',
        width: '145px'
      }
    ],
    userList: []
  }),
  computed: {
    gridLayout() {
      const result = [];

      this.titleList.forEach(prop => {
        result.push(prop.width || this.defaultWidth);
      });

      return result.join(' ');
    }
  }
};
</script>
